import React, { useEffect, useMemo, useState } from "react";
import Header from "../../components/header";
import Footer from "../../components/footer";
import ViewReportIcon from "../../assets/dasboard/view-results-image.svg";
import DownloadReportIcon from "../../assets/dasboard/download-report-image.svg";
import Arrow from "../../assets/sell/sell-button-arrow.svg";
import EmailReportIcon from "../../assets/dasboard/email-report-image.svg";
import RetakeTestIcon from "../../assets/dasboard/retake-test-image.svg";
import DeleteReportIcon from "../../assets/dasboard/delete-report-image.svg";
import SendToFriendIcon from "../../assets/dasboard/send-to-friend-image.svg";
import ShareReportIcon from "../../assets/dasboard/share-report-icon.svg";
import emailIcon from "../../assets/dasboard/email-icon.svg";
import ADHDIcon from "../../assets/assessment-icons/ADHD.svg";
import DiSCIcon from "../../assets/assessment-icons/DiSC.svg";
import PersonalityDisorderIcon from "../../assets/assessment-icons/personality-disorder.svg";
import shareIcon from "../../assets/dasboard/share-icon.svg";
import PlayIcon from "../../assets/dasboard/play.svg";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import RelationShip from "../../assets/sell/relationship-advice-pic.svg";
import LearningStyle from "../../assets/sell/learning-style-pic.svg";
import StressManagement from "../../assets/sell/stress-management-pic.svg";
import CareerIcon from "../../assets/assessment-icons/career.svg";
import BigFiveIcon from "../../assets/assessment-icons/big-five.svg";
import BigFiveFacetsIcon from "../../assets/assessment-icons/big-five-facets.svg";
import EnneagramIcon from "../../assets/assessment-icons/enneagram.svg";
import PersonalityIcon from "../../assets/assessment-icons/personality.svg";
import AllIcon from "../../assets/assessment-icons/All.svg";
import DifficultIcon from "../../assets/assessment-icons/difficult.svg";
import LikeabilityIcon from "../../assets/assessment-icons/likability.svg";
import FilterTestIcon from "../../assets/sell/filter-tests-icon.svg";
import NarcissisticIcon from "../../assets/assessment-icons/NPD.svg";
import LoveStyleIcon from "../../assets/assessment-icons/love-style.svg";
import HighlySensitiveIcon from "../../assets/assessment-icons/highly-sensitive.svg";
import FourTempermentsIcon from "../../assets/assessment-icons/four-temperments.svg";
import AntisocialIcon from "../../assets/assessment-icons/antisocial.svg";
import DyslexiaIcon from "../../assets/assessment-icons/dyslexia.svg";
import AutismIcom from "../../assets/assessment-icons/autism.svg";
import RomanticCompatibilityIcon from "../../assets/assessment-icons/romantic-compatibility.svg";
import ColorBlindness from "../../assets/assessment-icons/color-blindness.svg";
import Depression from "../../assets/assessment-icons/depression.svg";
import Bipolar from "../../assets/assessment-icons/icon-bipolar.svg";
import AttachmentStyleIcon from "../../assets/assessment-icons/attachment-style.svg";
import ShareProfileModal from "../../components/share-modal/component";
import AppPopOver from "../../components/popover";
import AppButton from "../../components/button/component";
import TraitProgressBar from "../../components/trait-progress-bar/component";
import { ROUTE_CONSTANT } from "../../routing/route-constants";
import FunnelStepTypes from "../funnel-step/types";
import { useDispatch } from "react-redux";
import moment from "moment";
import { createCookie, readCookie } from "../../utils/helpers";
import Guid from "guid";
import { toast } from "react-toastify";
import PathHelper from "../../utils/path-helper";
import {
  getOppositeTrait,
  getPersonalityType,
} from "../../utils/personality-helper";
import { CreateNewUserModel } from "../../components/model/component";
import {
  ADHD_TEST_ASSESSMENT_ID,
  ANTISOCIAL_PERSONALITY_DISORDER_ASSESSMENT_ID,
  ATTACHMENT_STYLE_TEST_ASSESSMENT_ID,
  AUTISM_SPECTRUM_TEST_ASSESSMENT_ID,
  BIG_FIVE_FACETS_TEST_ASSESSMENT_ID,
  BIG_FIVE_TEST_ASSESSMENT_ID,
  CAREER_PREFERENCE_TEST_ASSESSMENT_ID,
  CAREER_TEST_ASSESSMENT_ID,
  DIFFICULT_PERSON_TEST_ASSESSMENT_ID,
  DISC_TEST_ASSESSMENT_ID,
  DYSLEXIA_SCREENING_ADULT_TEST_ASSESSMENT_ID,
  EMOTIONAL_INTELLIGENCE_TEST_ASSESSMENT_ID,
  ENNEAGRAM_TEST_ASSESSMENT_ID,
  FOUR_TEMPERAMENTS_PERSONALITY_TEST_ASSESSMENT_ID,
  HIGHLY_SENSITIVE_PERSON_TEST_ASSESSMENT_ID,
  LIKEABILITY_TEST_ASSESSMENT_ID,
  LOVE_STYLE_TEST_ASSESSMENT_ID,
  MODEL_TYPE_DASHBOARD,
  NARCISSISTIC_PERSONALITY_DISORDER_ASSESSMENT_ID,
  PERSONALITY_DISORDER_TEST_ASSESSMENT_ID,
  PERSONALITY_TEST_ASSESSMENT_ID,
  ROMANTIC_COMPATIBILITY_ASSESSMENT_ID,
  COLOR_BLINDNESS_TEST_ASSESSMENT_ID,
  DEPRESSION_TEST_ASSESSMENT_ID,
  BIPOLAR_DISORDER_ASSESSMENT_ID,
} from "../../utils/general-config";
import Loader from "../../components/loader";
import {
  convertSpaceToHyphenAndLowerCase,
  convertToLowerCase,
  getBannerImage,
  getColorCode,
  getCookie,
  getImage,
  getRomanticCompatibilityImage,
  InvitationStatus,
  personalityNamesAndGroups,
  REPORT_ROUTES,
} from "../../utils/utility-functions";

import useSignOut from "../../utils/sign-out";
import { useTranslation } from "react-i18next";
import DashboardQuiz from "../../components/dashboard-quiz";
import {
  APP_NAVIGATION,
  ASSESSMENT_STATUS,
  LOCALE,
  ROMANTIC_COMPATIBILITY_REPORT_TYPE,
} from "../../utils/constants";
import { icon } from "@fortawesome/fontawesome-svg-core";

const pushResetSelectedAnswerCountToFunnelStep = () => ({
  type: FunnelStepTypes.RESET_SELECTED_ANSWER_COUNT,
});

const PushAssessmentAttemptIdToFunnelStep = (assessmentAttemptId) => ({
  type: FunnelStepTypes.SET_ASSESSMENT_ATTEMPT_ID,
  assessmentAttemptId,
});
const PushQuizCompleteToFunnelStep = (quizComplete) => ({
  type: FunnelStepTypes.SET_QUIZ_COMPLETE,
  quizComplete,
});
const PushAssessmentIdToFunnelStep = (assessmentId) => ({
  type: FunnelStepTypes.SET_ASSESSMENT_ID,
  assessmentId,
});

const PushBackClickCountToFunnelStep = (backCount) => ({
  type: FunnelStepTypes.SET_BACk_BUTTON_CLICK_COUNT,
  backCount,
});

const PushGuestUserToFunnelStep = (guestUser) => {
  return {
    type: FunnelStepTypes.SET_GUEST_USER,
    guestUser,
  };
};
const PushUserInformationToFunnelStep = (userInformation) => ({
  type: FunnelStepTypes.SET_USERINFO,
  payload: userInformation,
});

const Dashboard = ({
  getAssessmentResultByAssessmentAttemptIdConnect,
  getAssessmentAttemptByUserIdConnect,
  getAssessmentByIdConnect,
  funnelStep,
  DownloadAssessmentResultConnect,
  GetUserByIdConnect,
  IsGuestOrPremiumUserConnect,
  ShareReportOnEmailConnect,
  DeleteReport,
  GetGuestUserConnect,
  GetTransactionDetailConnect,
  GetBillingConnect,
  GuestUserChangesConnect,
  getInsightfulContentConnect,
  sendToFriendReportOnEmailConnect,
  sendToPartnerReportOnEmailConnect,
  isCompleteRomanticCompatibilityConnect,
  getUserAssessmentResultMapByUserIdConnect,
  getUserAssessmentResultByResultIdConnect,
  saveUserSocialButtonClickConnect,
}) => {
  const newAssessmentAttemptId = Guid.create().value;
  const navigate = useNavigate();
  const location = useLocation();
  const [guestUserCount, setGuestUserCount] = useState(0);
  const {
    userGUID,
    assessmentAttemptId,
    selectedPlan,
    isGuestUser,
    gender,
    assessmentId,
    isAuth,
  } = funnelStep || {};
  const { t } = useTranslation();
  const { locale } = useParams();
  const currentLocale = locale ?? LOCALE.EN;

  // const isGuestQueryString = queryParams.get("isguest") === "true";
  // console.log("hello", isGuestQueryString);
  // const token = readCookie("jwtToken");
  const [personalityInProgress, setPersonalityInProgress] = useState(false);
  const [openSendToFriend, setOpenSendToFriend] = useState(false);
  const [openSendToPartner, setOpenSendToPartner] = useState(false);
  const [assessmentTitle, setAssessmentTitle] = useState("");
  const [assessmentAttemptData, setAssessmentAttemptData] = useState([]);
  const [openNewTest, setOpenNewTest] = React.useState(false);
  const [userAssessmentResult, setUserAssessmentResult] = useState({});
  const [popoverOpen, setPopoverOpen] = React.useState({});
  const [isPremiumOrGuest, setIsPremiumOrGuest] = React.useState(false);
  const [transactionDetails, setTransactionDetail] = useState(null);
  const [skuId, setSkuId] = useState("");
  const [billingDetails, setBillingDetails] = useState(null);
  const [openCreateUser, setOpenCreateUser] = useState(false);
  const [guestUserData, setGuestUserData] = useState([]);
  const [userData, setUserData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [insightfulContent, setInsightfulContent] = useState({});
  const [romanticCompatibilityStatus, setRomanticCompatibilityStatus] =
    useState({});
  const [selectedAssessmentId, setSelectedAssessmentId] = useState("");
  const [selectedAssessmentAttemptId, setSelectedAssessmentAttemptId] =
    useState("");
  const [selectedAssessmentMapId, setSelectedAssessmentMaoId] = useState("");
  const [selectedReportType, setSelectedReportType] = useState(null);
  const [selectedResultId, setSelectedResultId] = useState(null);
  const [testPanelOpen, setTestPanelOpen] = useState(null);
  const [
    inCompletePersonalityAssessmentId,
    setInCompletePersonalityAssessmentId,
  ] = useState("");
  const handlePopoverClick = (index) => {
    setPopoverOpen((prevOpen) => (prevOpen === index ? null : index));
    setOpenNewTest(false);
  };
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [selectedTest, setSelectedTest] = useState(null);
  const [userAssessmentResulMapData, setUserAssessmentResulMapData] = useState(
    [],
  );
  const [userAssessmentResultById, setUserAssessmentResultById] = useState([]);
  const [
    isUserAssessmentResulMapDataLoading,
    setIsUserAssessmentResulMapDataLoading,
  ] = useState(false);

  const dispatch = useDispatch();

  const TEST_TYPES = {
    [PERSONALITY_TEST_ASSESSMENT_ID]: "PersonalityTest",
    [BIG_FIVE_TEST_ASSESSMENT_ID]: "BigFiveTest",
    [CAREER_TEST_ASSESSMENT_ID]: "CareerTest",
    [ENNEAGRAM_TEST_ASSESSMENT_ID]: "EnneagramTest",
    [BIG_FIVE_FACETS_TEST_ASSESSMENT_ID]: "BigFiveFacetsTest",
    [LIKEABILITY_TEST_ASSESSMENT_ID]: "LikeabilityTest",
    [PERSONALITY_DISORDER_TEST_ASSESSMENT_ID]: "PersonalityDisorderTest",
    [DISC_TEST_ASSESSMENT_ID]: "DiscPersonalityTest",
    [ADHD_TEST_ASSESSMENT_ID]: "ADHDTest",
    [CAREER_PREFERENCE_TEST_ASSESSMENT_ID]: "CareerPreferenceTest",
    [EMOTIONAL_INTELLIGENCE_TEST_ASSESSMENT_ID]: "EmotionalIntelligenceTest",
    [DIFFICULT_PERSON_TEST_ASSESSMENT_ID]: "DifficultPersonTest",
    [AUTISM_SPECTRUM_TEST_ASSESSMENT_ID]: "AutismSpectrumTest",
    [HIGHLY_SENSITIVE_PERSON_TEST_ASSESSMENT_ID]: "HighlySensitivePersonTest",
    [ATTACHMENT_STYLE_TEST_ASSESSMENT_ID]: "AttachmentStyleTest",
    [ROMANTIC_COMPATIBILITY_ASSESSMENT_ID]: "RomanticCompatibilityTest",
  };

  const fetchUserAssessmentData = async () => {
    if (userGUID) {
      setIsUserAssessmentResulMapDataLoading(true);
      try {
        const res = await getUserAssessmentResultMapByUserIdConnect(userGUID);
        setUserAssessmentResulMapData(res);
        setUserAssessmentResultById([]); // Reset the array before populating

        const resultPromises = res.map((item) =>
          getUserAssessmentResultByResultIdConnect(
            item.userAssessmentResultId,
            currentLocale,
          ).then((res) => {
            if (res) {
              setUserAssessmentResultById((prev) => [...(prev || []), res]);
            }
          }),
        );

        await Promise.all(resultPromises);
      } catch (err) {
        console.error("Failed to fetch assessment result map:", err);
      } finally {
        setIsUserAssessmentResulMapDataLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchUserAssessmentData();
  }, [userGUID]);

  useEffect(() => {
    const fetchData = async () => {
      if (!userGUID || isUserAssessmentResulMapDataLoading) return; // Exit if userGUID is not available
      setIsLoading(true);

      try {
        // 1. Fetch Assessment Attempt Data
        const assessmentAttemptData = await getAssessmentAttemptByUserIdConnect(
          userGUID,
          currentLocale,
        );
        setAssessmentAttemptData(assessmentAttemptData);

        // 2. Determine latestAssessmentAttemptId from completed results
        const completedAssessmentResult = assessmentAttemptData.filter(
          (item) =>
            item.assessmentId === PERSONALITY_TEST_ASSESSMENT_ID &&
            item.personality !== null,
        );

        const inCompletedAssessmentResult = assessmentAttemptData.filter(
          (item) =>
            item.assessmentId === PERSONALITY_TEST_ASSESSMENT_ID &&
            item.personality === null,
        );
        const latestPersonalityInprogress = inCompletedAssessmentResult.sort(
          (a, b) => new Date(b.createdOn) - new Date(a.createdOn),
        );

        const latestPersonalityInprogressAttemptId =
          latestPersonalityInprogress[0]?.assessmentAttemptId;

        if (latestPersonalityInprogress.length > 0) {
          setPersonalityInProgress(true);
          setInCompletePersonalityAssessmentId(
            latestPersonalityInprogressAttemptId,
          );
        }

        const latestAttempt = completedAssessmentResult.sort(
          (a, b) => new Date(b.createdOn) - new Date(a.createdOn),
        )[0];
        const latestAssessmentAttemptId = latestAttempt?.assessmentAttemptId;

        if (!latestAssessmentAttemptId) return; // Exit if no valid attempt found

        // 3. Fetch User Assessment Result
        const userAssessmentResult =
          await getAssessmentResultByAssessmentAttemptIdConnect(
            latestAssessmentAttemptId,
            currentLocale,
          );
        setUserAssessmentResult(userAssessmentResult);

        // 4. Fetch Insightful Content based on userAssessmentResult
        if (userAssessmentResult?.personality) {
          const data = {
            modelType: MODEL_TYPE_DASHBOARD[currentLocale],
            contentKey: userAssessmentResult.personality.title.toLowerCase(),
          };
          const insightfulContent = await getInsightfulContentConnect(data);
          setInsightfulContent(insightfulContent);
        }
      } catch (error) {
        console.error(error); // Log errors from any of the fetch operations
      } finally {
        setIsLoading(false); // Stop loading state only after all operations complete
      }
    };

    fetchData();
  }, [
    userGUID,
    getAssessmentAttemptByUserIdConnect,
    getAssessmentResultByAssessmentAttemptIdConnect,
    getInsightfulContentConnect,
  ]);

  const signOut = useSignOut();
  useEffect(() => {
    if (!isAuth) {
      signOut({ isNavigate: true });
    }
  }, [isAuth]);

  useEffect(() => {
    if (userGUID) {
      IsGuestOrPremiumUserConnect(userGUID).then((res) => {
        if (!!res) {
          const flag = res?.isPremiumOrGuestUser;
          setIsPremiumOrGuest(flag);
          // createCookie("isPremiumOrGuest", flag, 1);
          const queryParams = new URLSearchParams(window.location.search);
          let isGuestFromQuery = queryParams.has("isguest");
          const shouldSkipTransaction = isGuestUser || isGuestFromQuery;
          if (!shouldSkipTransaction) {
            GetTransactionDetailConnect(userGUID).then((res) => {
              if (res && Object.keys(res).length > 0) {
                const gatewayRequest = res.gatewayRequest;
                setTransactionDetail(res);
                try {
                  const jsonReq = JSON.parse(gatewayRequest);
                  setSkuId(jsonReq?.SKUGuid ?? null);
                } catch (error) {
                  setSkuId(null); // optional fallback
                }
              } else {
                setSkuId(null);
              }
            });
          }
        }
      });
    }
  }, [userGUID]);

  const romanticCompatibilityData =
    userAssessmentResultById?.map((result) => ({
      id: result.id,
      assessmentId: result?.assessmentId,
      title: result?.assessmentTitle,
      date: result?.createdOn,
      assessmentAttemptId: result?.assessmentAttemptId,
      personality: result?.personality,
      assessmentMapId: result?.assessmentMapId,
      createdOn: result?.createdOn,
      nameEnglishCode: result?.nameEnglishCode,
      subtitle: t("report.romantic_compatibility.compatibility_report"),
      // Set reportType for compatibility reports
      reportType: ROMANTIC_COMPATIBILITY_REPORT_TYPE.COMPATIBILITY,
    })) || [];

  const mappedData =
    assessmentAttemptData?.length > 0
      ? assessmentAttemptData.map((item) => ({
          id: item?.id,
          assessmentId: item?.assessmentId,
          title: item?.assessmentTitle,
          subtitle:
            convertToLowerCase(item?.assessmentId) ===
            convertToLowerCase(ROMANTIC_COMPATIBILITY_ASSESSMENT_ID)
              ? t("report.romantic_compatibility.personalized_report")
              : "",
          date: item?.createdOn,
          assessmentAttemptId: item?.assessmentAttemptId,
          personality: item?.personality,
          assessmentMapId: item?.assessmentMapId,
          createdOn: item?.createdOn,
          nameEnglishCode: item?.nameEnglishCode,
          // Add reportType for romantic compatibility assessments
          reportType:
            convertToLowerCase(item?.assessmentId) ===
            convertToLowerCase(ROMANTIC_COMPATIBILITY_ASSESSMENT_ID)
              ? ROMANTIC_COMPATIBILITY_REPORT_TYPE.PERSONALIZED
              : null,
        }))
      : [];

  // const userGivenAssessmentData = [...mappedData];
  let userGivenAssessmentData = [];

  if (romanticCompatibilityData?.length > 0 && mappedData.length > 0) {
    userGivenAssessmentData = [...romanticCompatibilityData, ...mappedData];
  } else if (romanticCompatibilityData?.length > 0) {
    userGivenAssessmentData = [...romanticCompatibilityData];
  } else {
    userGivenAssessmentData = [...mappedData];
  }
  userGivenAssessmentData = userGivenAssessmentData.sort(
    (a, b) => new Date(b.createdOn).getTime() - new Date(a.createdOn).getTime(),
  );

  const selectedAssessment = userGivenAssessmentData.find(
    (item) => item.assessmentAttemptId === testPanelOpen,
  );

  const traits = userAssessmentResult?.userTraits ?? [];

  const personalityType = userAssessmentResult
    ? userAssessmentResult?.personality?.title
    : "";
  const personalityGroup = userAssessmentResult
    ? userAssessmentResult?.personality?.role
    : "";
  const personalityName = userAssessmentResult
    ? userAssessmentResult?.personality?.name
    : "";
  const personalityNameEnglishCode = userAssessmentResult
    ? userAssessmentResult?.personality?.nameEnglishCode
    : "";

  const personalityImage = getImage(
    personalityGroup,
    personalityNameEnglishCode,
    false,
    gender || userData?.gender,
  );

  useEffect(() => {
    if (isAuth) {
      // createCookie("avatarImg", personalityImage, 1);
      dispatch(
        PushUserInformationToFunnelStep({
          avatarImg: personalityImage,
        }),
      );
    }
  }, [isAuth, personalityImage]);

  const tratiPercentage =
    traits &&
    traits?.map((item) => {
      return {
        ...item,
        percentage: item.percentage,
        leftTrait:
          item.percentage <= 50
            ? getPersonalityType(item?.trait?.title, t)
            : getOppositeTrait(item?.trait?.title, t),
        rightTrait:
          item.percentage > 50
            ? getPersonalityType(item?.trait?.title, t)
            : getOppositeTrait(item?.trait?.title, t),
        traitTitle: getPersonalityType(item?.trait?.title, t),
      };
    });

  useEffect(() => {
    getAssessmentByIdConnect(currentLocale).then((response) => {
      setAssessmentTitle(response);
    });
  }, [getAssessmentByIdConnect]);

  const completedAssessmentResult = assessmentAttemptData?.filter((item) => {
    return (
      item?.assessmentId === PERSONALITY_TEST_ASSESSMENT_ID &&
      item?.personality !== null
    );
  });

  const latestAssessmentAttemptId = completedAssessmentResult
    ?.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn)) // Sort by createdOn in descending order
    ?.map((item, index) => {
      if (index === 0) {
        return item.assessmentAttemptId; // Return the assessmentAttemptId of the first item
      }
    })
    ?.filter(Boolean)[0];

  const latestAssessmentId = completedAssessmentResult
    ?.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn)) // Sort by createdOn in descending order
    ?.map((item, index) => {
      if (index === 0) {
        return item.assessmentId; // Return the assessmentAttemptId of the first item
      }
    })
    ?.filter(Boolean)[0];

  const assessmentIcons = [
    { key: PERSONALITY_TEST_ASSESSMENT_ID, icon: PersonalityIcon },
    { key: CAREER_TEST_ASSESSMENT_ID, icon: CareerIcon },
    // { key: "Relationship", icon: RelationShip },
    // { key: "Learning", icon: LearningStyle },
    // { key: "Stress", icon: StressManagement },
    { key: BIG_FIVE_FACETS_TEST_ASSESSMENT_ID, icon: BigFiveFacetsIcon },
    { key: BIG_FIVE_TEST_ASSESSMENT_ID, icon: BigFiveIcon },
    { key: ENNEAGRAM_TEST_ASSESSMENT_ID, icon: EnneagramIcon },
    { key: ADHD_TEST_ASSESSMENT_ID, icon: ADHDIcon },
    { key: DISC_TEST_ASSESSMENT_ID, icon: DiSCIcon },
    {
      key: PERSONALITY_DISORDER_TEST_ASSESSMENT_ID,
      icon: PersonalityDisorderIcon,
    },
    {
      key: LIKEABILITY_TEST_ASSESSMENT_ID,
      icon: LikeabilityIcon,
    },
    {
      key: DIFFICULT_PERSON_TEST_ASSESSMENT_ID,
      icon: DifficultIcon,
    },
    {
      key: NARCISSISTIC_PERSONALITY_DISORDER_ASSESSMENT_ID,
      icon: NarcissisticIcon,
    },
    {
      key: HIGHLY_SENSITIVE_PERSON_TEST_ASSESSMENT_ID,
      icon: HighlySensitiveIcon,
    },
    {
      key: AUTISM_SPECTRUM_TEST_ASSESSMENT_ID,
      icon: AutismIcom,
    },
    {
      key: ATTACHMENT_STYLE_TEST_ASSESSMENT_ID,
      icon: AttachmentStyleIcon,
    },
    {
      key: FOUR_TEMPERAMENTS_PERSONALITY_TEST_ASSESSMENT_ID,
      icon: FourTempermentsIcon,
    },
    {
      key: LOVE_STYLE_TEST_ASSESSMENT_ID,
      icon: LoveStyleIcon,
    },
    {
      key: ANTISOCIAL_PERSONALITY_DISORDER_ASSESSMENT_ID,
      icon: AntisocialIcon,
    },
    {
      key: DYSLEXIA_SCREENING_ADULT_TEST_ASSESSMENT_ID,
      icon: DyslexiaIcon,
    },
    {
      key: ROMANTIC_COMPATIBILITY_ASSESSMENT_ID,
      icon: RomanticCompatibilityIcon,
    },
    {
      key: COLOR_BLINDNESS_TEST_ASSESSMENT_ID,
      icon: ColorBlindness,
    },
    {
      key: DEPRESSION_TEST_ASSESSMENT_ID,
      icon: Depression,
    },
    {
      key: BIPOLAR_DISORDER_ASSESSMENT_ID,
      icon: Bipolar,
    },
  ];

  const assessmentOptions =
    assessmentTitle?.length &&
    [...assessmentTitle]
      .sort((a, b) => b.title.localeCompare(a.title)) //sorting the array in alphabetical order
      .map((item) => {
        const matchingIcon = assessmentIcons.find(
          (iconItem) =>
            item?.id.trim().toLowerCase() === iconItem.key.trim().toLowerCase(),
        );

        return {
          id: item.id,
          label: item.title,
          icon: matchingIcon ? matchingIcon.icon : PersonalityIcon, // Default to PersonalizedInsights if no match
          onClick: () => {
            if (isPremiumOrGuest) {
              const path = PathHelper(APP_NAVIGATION.QUIZ, currentLocale);
              navigate(`${path.next}?assessmentId=${item.id}&newt=true`); // for example
              // navigate(
              //   `${ROUTE_CONSTANT.QUIZ}?assessmentId=${item.id}&newt=true`
              // );
              dispatch(PushAssessmentIdToFunnelStep(item.id));
              handleTestClick();
            } else {
              const path = PathHelper(APP_NAVIGATION.PLAN, currentLocale);
              navigate(`${path.next}`); // for example
              // navigate(`${ROUTE_CONSTANT.PAYMENT_PLAN}`);
            }
          },
        };
      });

  const getAllAssessmentData =
    (assessmentTitle?.length &&
      assessmentTitle
        .filter((item) => item.id !== COLOR_BLINDNESS_TEST_ASSESSMENT_ID)
        .map((item) => ({
          id: item.id,
          title: item.title,
        }))) ||
    [];
  const getAllAssessmentAttemptData =
    (assessmentAttemptData.length &&
      assessmentAttemptData?.map((item) => item.assessmentId)) ||
    [];

  const notAttemptedAssessments = getAllAssessmentData.filter(
    (assessment) => !getAllAssessmentAttemptData.includes(assessment.id),
  );

  const handleTestClick = () => {
    dispatch(pushResetSelectedAnswerCountToFunnelStep());
    dispatch(PushAssessmentAttemptIdToFunnelStep(newAssessmentAttemptId));
    dispatch(PushQuizCompleteToFunnelStep(false));
    localStorage.removeItem("userAnswers");
  };

  const handleViewReportDashboard = () => {
    if (latestAssessmentAttemptId && isPremiumOrGuest) {
      const path = PathHelper(APP_NAVIGATION.PERSONALITY_REPORT, currentLocale);
      navigate(`${path.next}?aai=${latestAssessmentAttemptId}&uid=${userGUID}`); // for example
      // navigate(
      //   `${ROUTE_CONSTANT.PERSONALITY_REPORT}?aai=${latestAssessmentAttemptId}&uid=${userGUID}`
      // );
    } else {
      navigate(`${planPath.next}`); // for example
      // navigate(ROUTE_CONSTANT.PAYMENT_PLAN);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [isLoading]);

  const handleViewReport = (
    isPremiumOrGuest,
    assessmentAttemptId,
    assessmentId,
    id,
    reportType = null,
  ) => {
    const isRomanticCompatibilityTest =
      convertToLowerCase(assessmentId) ===
      convertToLowerCase(ROMANTIC_COMPATIBILITY_ASSESSMENT_ID);
    let reportRoute;

    if (isRomanticCompatibilityTest) {
      const romanticRoutes = REPORT_ROUTES[assessmentId];
      if (reportType === ROMANTIC_COMPATIBILITY_REPORT_TYPE.PERSONALIZED) {
        reportRoute = romanticRoutes?.personal;
      } else {
        // Default to compatibility report (when reportType is "compatibility" or null)
        reportRoute = romanticRoutes?.compatibility;
      }
    } else {
      reportRoute = REPORT_ROUTES[assessmentId];
    }

    if (!reportRoute) {
      console.error(`No route found for assessmentId: ${assessmentId}`);
      return;
    }

    if (isPremiumOrGuest || isRomanticCompatibilityTest) {
      const path = PathHelper(reportRoute, locale);

      let queryParams = "";

      if (reportType === ROMANTIC_COMPATIBILITY_REPORT_TYPE.COMPATIBILITY) {
        // Only include assessresid for compatibility
        queryParams = `?assessresid=${id}`;
      } else {
        // Default case: include aai and uid
        queryParams = `?aai=${assessmentAttemptId}&uid=${userGUID}`;
      }

      navigate(`${path.next}${queryParams}`);
    } else {
      navigate(`${planPath.next}`);
    }
  };

  const handleRetakeTest = (isPremiumOrGuest, item) => {
    if (isPremiumOrGuest) {
      handleTestClick();
      dispatch(PushAssessmentIdToFunnelStep(item.assessmentId));
      const path = PathHelper(APP_NAVIGATION.QUIZ, currentLocale);
      navigate(`${path.next}?assessmentId=${item.assessmentId}`); // for example
    } else {
      navigate(`${planPath.next}`); // for example
    }
  };

  const handleShareReport = (isPremiumOrGuest, item) => {
    if (isPremiumOrGuest) {
      setTestPanelOpen(null);
      setShareModalOpen(true);
      setSelectedTest(item);
      setPopoverOpen(false);
    } else {
      navigate(`${planPath.next}`); // for example
    }
  };

  const handleEmailReport = async (isPremiumOrGuest, data, item) => {
    if (!isPremiumOrGuest) {
      navigate(`${planPath.next}`); // for example
      return;
    }
    setPopoverOpen({});
    setTestPanelOpen(null);
    setIsButtonLoading(true);
    try {
      const emailResponse = await ShareReportOnEmailConnect(data);

      if (emailResponse.success) {
        toast.success(t("dashboard.report_sent_success_onemail_msg"));
      } else {
        const downloadResponse = await DownloadAssessmentResultConnect(
          userGUID,
          item.assessmentAttemptId,
          currentLocale !== LOCALE.EN && currentLocale,
        );

        if (downloadResponse) {
          const retryEmailResponse = await ShareReportOnEmailConnect(data);

          if (retryEmailResponse.success) {
            toast.success(t("dashboard.report_sent_success_onemail_msg"));
          } else {
            toast.error(t("dashboard.report_sent_fail_msg"));
          }
        }
      }
    } catch (error) {
      toast.error(t("dashboard.report_error_msg"));
    } finally {
      setIsButtonLoading(false);
    }
  };

  const handleSendToFriend = (isPremiumOrGuest, item) => {
    if (!isPremiumOrGuest) {
      navigate(`${planPath.next}`); // for example
    } else {
      setPopoverOpen({});
      setTestPanelOpen(null);
      setOpenSendToFriend(true);
      setSelectedAssessmentId(item?.assessmentId);
      setSelectedAssessmentAttemptId(item?.assessmentAttemptId);
      setSelectedResultId(item?.id);
      const reportType = item?.reportType;
      setSelectedReportType(reportType);
    }
  };

  const handleSendToPartner = (isPremiumOrGuest, item) => {
    setPopoverOpen({});
    setTestPanelOpen(null);
    setOpenSendToPartner(true);
    setSelectedAssessmentId(item?.assessmentId);
    setSelectedAssessmentAttemptId(item?.assessmentAttemptId);
    setSelectedAssessmentMaoId(item?.assessmentMapId);
  };

  const handleDeleteReport = (
    isPremiumOrGuest,
    assessmentId,
    assessmentAttemptId,
    id,
  ) => {
    if (!isPremiumOrGuest) {
      navigate(`${planPath.next}`); // for example
    } else {
      const data = {
        assessmentId,
        assessmentAttemptId,
        userGuid: userGUID,
        resultId: id,
      };

      DeleteReport(data).then((res) => {
        if (res.success) {
          toast.success(`${t("dashboard.report_delete_success_message")}`);
          getAssessmentAttemptByUserIdConnect(userGUID, currentLocale).then(
            (response) => {
              setAssessmentAttemptData(response);
            },
          );
          fetchUserAssessmentData(); // Use the new function to refresh all assessment data
          setPopoverOpen({});
        }
      });
    }
  };

  const handleDownloadReport = async (
    isPremiumOrGuest,
    assessmentAttemptId,
  ) => {
    if (isPremiumOrGuest) {
      setIsButtonLoading(true);
      setPopoverOpen({});
      try {
        const res = await DownloadAssessmentResultConnect(
          userGUID,
          assessmentAttemptId,
          currentLocale !== LOCALE.EN && currentLocale,
        );
        if (res && res.hrefBlobUrl) {
          window.open(res.hrefBlobUrl, "_blank");
        } else {
          toast.error("Failed to download assessment result.");
        }
      } catch (error) {
        toast.error(
          "An error occurred while downloading the assessment result.",
        );
      } finally {
        setIsButtonLoading(false);
      }
    } else {
      navigate(`${planPath.next}`); // for example
    }
  };

  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
  const toggleFilterPanel = () => {
    setIsFilterPanelOpen(!isFilterPanelOpen);
  };

  const personalityColorDark = getColorCode(
    personalityGroup && personalityGroup,
  ).dark;
  const personalityColorLight = getColorCode(
    personalityGroup && personalityGroup,
  ).light;

  const personalityColorMedium = getColorCode(
    personalityGroup && personalityGroup,
  ).medium;

  const bannerImage = getBannerImage(personalityGroup);

  const scrollAndHighlightElement = (elementId, duration = 2000) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      // Add temporary highlight class
      element.classList.add("ring", "ring-[#805AED]", "ring-opacity-100");
      // Remove highlight after animation
      setTimeout(() => {
        element.classList.remove("ring", "ring-[#805AED]", "ring-opacity-100");
      }, duration);
    }
  };

  const [currentFilter, setCurrentFilter] = useState("All");

  useEffect(() => {
    if (userGUID) {
      GetUserByIdConnect(userGUID).then((res) => {
        if (res) {
          setUserData(res);
          const fullName =
            [res?.firstName, res?.lastName]
              .filter((name) => name && name.trim().length > 0)
              .join(" ") || res?.userName;
          dispatch(
            PushUserInformationToFunnelStep({
              uname: fullName,
              accnum: res?.accountNumber,
            }),
          );
          // createCookie("userguid", res?.userGuid, 1);
          // createCookie("uname", fullName, 1);
          // createCookie("accnum", res?.accountNumber, 1);
          if (res.parentUserGuid && res?.parentUserGuid !== Guid.EMPTY) {
            dispatch(PushGuestUserToFunnelStep(true));
          }
        }
      });

      GetGuestUserConnect(userGUID).then((res) => {
        if (res) {
          const filteredData = res.filter(
            (item) =>
              item.invitationStatus === InvitationStatus.Sent ||
              item?.invitationStatus === InvitationStatus.Accepted,
          );
          const nonRemovedInvitations = res.filter(
            (item) => item.invitationStatus !== InvitationStatus.Removed,
          );
          setGuestUserCount(filteredData.length);
          setGuestUserData(nonRemovedInvitations);
          // createCookie("guestUserCount", filteredData.length, 1);
        }
      });
    }
  }, [userGUID]);

  useEffect(() => {
    if (transactionDetails && transactionDetails?.id) {
      let skuGuid = selectedPlan?.id;
      if (!skuGuid) {
        skuGuid = skuId;
      }
      const data = {
        skuGuid: skuGuid,
        transId: transactionDetails?.id,
        locale: "en",
      };
      GetBillingConnect(data).then((res) => {
        setBillingDetails(res);
        if (res && res.maxSubUserCount !== undefined) {
          PushUserInformationToFunnelStep({
            maxSubUserCount: res.maxSubUserCount,
          });
          // createCookie("maxSubUserCount", res.maxSubUserCount, 1);
        }
      });
    }
  }, [transactionDetails]);

  // useEffect(() => {
  //   if (
  //     selectedAssessment?.assessmentId ===
  //       ROMANTIC_COMPATIBILITY_ASSESSMENT_ID &&
  //     selectedAssessment?.assessmentMapId
  //   ) {
  //     checkRomanticCompatibilityStatus(selectedAssessment.assessmentMapId);
  //   }
  // }, [selectedAssessment?.assessmentMapId, selectedAssessment?.assessmentId]);

  // const checkRomanticCompatibilityStatus = (assessmentMapId) => {
  //   if (!assessmentMapId) return false;

  //   if (romanticCompatibilityStatus[assessmentMapId] !== undefined) {
  //     return romanticCompatibilityStatus[assessmentMapId];
  //   }

  //   // Only make API call if not already in progress
  //   if (!romanticCompatibilityStatus[`${assessmentMapId}_loading`]) {
  //     // Mark as loading to prevent duplicate calls
  //     setRomanticCompatibilityStatus((prev) => ({
  //       ...prev,
  //       [`${assessmentMapId}_loading`]: true,
  //     }));

  //     isCompleteRomanticCompatibilityConnect(assessmentMapId)
  //       .then((response) => {
  //         setRomanticCompatibilityStatus((prev) => ({
  //           ...prev,
  //           [assessmentMapId]: response || false,
  //           [`${assessmentMapId}_loading`]: false,
  //         }));
  //       })
  //       .catch((error) => {
  //         console.error(
  //           "Error checking romantic compatibility completion:",
  //           error
  //         );
  //         setRomanticCompatibilityStatus((prev) => ({
  //           ...prev,
  //           [assessmentMapId]: false,
  //           [`${assessmentMapId}_loading`]: false,
  //         }));
  //       });
  //   }

  //   return false;
  // };

  const handleContinueTest = (
    assessmentId,
    assessmentAttemptId,
    isPremiumOrGuest,
  ) => {
    if (isPremiumOrGuest) {
      dispatch(PushAssessmentAttemptIdToFunnelStep(assessmentAttemptId));
      dispatch(PushQuizCompleteToFunnelStep(false));
      dispatch(PushBackClickCountToFunnelStep(0));
      dispatch(PushAssessmentIdToFunnelStep(assessmentId));
      const path = PathHelper(APP_NAVIGATION.QUIZ, currentLocale);
      navigate(
        `${path.next}?assessmentId=${assessmentId}&assessmentAttemptId=${assessmentAttemptId}`,
      ); // for example
    } else {
      const path = PathHelper(APP_NAVIGATION.PLAN, currentLocale);
      navigate(`${path.next}`); // for example
    }
    setTestPanelOpen(null);
  };
  const isParentUser = userData && userData?.parentUserGuid === Guid.EMPTY;

  useEffect(() => {
    const guestUserCountValue = guestUserCount;
    const maxSubUserCount = billingDetails?.maxSubUserCount;

    // Store values in cookies
    // if (guestUserCountValue !== undefined) {
    //   createCookie("guestUserCount", guestUserCountValue, 1);
    // }
    if (maxSubUserCount !== undefined) {
      // createCookie("maxSubUserCount", maxSubUserCount, 1);
      PushUserInformationToFunnelStep({
        maxSubUserCount: maxSubUserCount,
      });
    }
  }, [guestUserCount, billingDetails?.maxSubUserCount]);

  const getMobileActions = () => {
    const isComplete = selectedAssessment?.personality;
    const reportType = selectedAssessment?.reportType;

    if (!isComplete) {
      return [
        {
          id: "dasboard-continue-test",
          label: `${t("dasboard-continue-test")}`,
          icon: PlayIcon,
          onClick: () =>
            handleContinueTest(
              selectedAssessment.assessmentId,
              selectedAssessment.assessmentAttemptId,
              isPremiumOrGuest,
            ),
        },
      ];
    }

    const baseActions = [
      {
        id: "dasboard-view-report",
        label: `${t("dashboard.view_report_cta")}`,
        icon: ViewReportIcon,
        onClick: () => {
          handleViewReport(
            isPremiumOrGuest,
            selectedAssessment?.assessmentAttemptId,
            selectedAssessment?.assessmentId,
            selectedAssessment?.id,
            reportType,
          );
          setTestPanelOpen(null);
        },
      },
      {
        id: "dasboard-retake-test",
        label: `${t("dashboard.retake_test")}`,
        icon: RetakeTestIcon,
        onClick: () => {
          handleRetakeTest(isPremiumOrGuest, selectedAssessment);
          setTestPanelOpen(null);
        },
      },
      { type: "divider" },
      {
        id: "dasboard-share-report",
        label: `${t("dashboard.share_report")}`,
        icon: ShareReportIcon,
        onClick: () => handleShareReport(isPremiumOrGuest, selectedAssessment),
      },
      {
        id: "dasboard-send-to-friend",
        label: `${t("dashboard.send_to_friend")}`,
        icon: SendToFriendIcon,
        onClick: () => handleSendToFriend(isPremiumOrGuest, selectedAssessment),
      },
    ];

    // Hide standard View Report for RomanticCompatibilityTest
    const commonActions = baseActions;

    const deleteAction = {
      id: "dasboard-delete-report",
      label: `${t("dashboard.delete_report")}`,
      icon: DeleteReportIcon,
      onClick: () => {
        handleDeleteReport(
          isPremiumOrGuest,
          selectedAssessment.assessmentId,
          selectedAssessment.assessmentAttemptId,
          selectedAssessment.id,
        );
        setTestPanelOpen(null);
      },
      className: "text-red-500",
    };

    const extraActions = {
      [PERSONALITY_TEST_ASSESSMENT_ID]: [
        {
          id: "dasboard-personality-download-report",
          label: `${t("dashboard.download_report")}`,
          icon: DownloadReportIcon,
          onClick: () => {
            handleDownloadReport(
              isPremiumOrGuest,
              selectedAssessment.assessmentAttemptId,
            );
            setTestPanelOpen(null);
          },
        },
        {
          id: "dasboard-email-report",
          label: `${t("dashboard.email_report")}`,
          icon: EmailReportIcon,
          onClick: () => {
            handleEmailReport(
              isPremiumOrGuest,
              {
                userGuid: userGUID,
                assessmentAttemptId: selectedAssessment.assessmentAttemptId,
                locale: currentLocale,
              },
              selectedAssessment,
            );
          },
        },
        { type: "divider" },
      ],
      [ROMANTIC_COMPATIBILITY_ASSESSMENT_ID]: [
        // {
        //   label: "Personalized Report",
        //   icon: ViewReportIcon,
        //   onClick: () => {
        //     handleViewReport(
        //       isPremiumOrGuest,
        //       selectedAssessment?.assessmentAttemptId,
        //       selectedAssessment?.assessmentId,
        //       "personal"
        //     );
        //     setTestPanelOpen(null);
        //   },
        // },
        // ...(checkRomanticCompatibilityStatus(
        //   selectedAssessment?.assessmentMapId
        // )
        //   ? [
        //       {
        //         label: "Compatibility Report",
        //         icon: ViewReportIcon,
        //         onClick: () => {
        //           handleViewReport(
        //             isPremiumOrGuest,
        //             selectedAssessment?.assessmentAttemptId,
        //             selectedAssessment?.assessmentId,
        //             "compatibility"
        //           );
        //           setTestPanelOpen(null);
        //         },
        //       },
        //     ]
        //   : []),
        ...(isParentUser
          ? [
              {
                id: "dasboard-send-to-partner",
                label: `${t("dashboard.send_to_partner")}`,
                icon: DownloadReportIcon,
                onClick: () => {
                  handleSendToPartner(isPremiumOrGuest, selectedAssessment);
                  setTestPanelOpen(null);
                },
              },
            ]
          : []),
        { type: "divider" },
      ],
    };

    const defaultActions = [
      ...commonActions,
      { type: "divider" },
      deleteAction,
    ];

    return [
      ...(extraActions[selectedAssessment?.assessmentId] || []),
      ...defaultActions,
    ];
  };

  const filteredData = userGivenAssessmentData.filter((item) => {
    if (currentFilter === "All") return true;
    return item.assessmentId === currentFilter; // Compare with assessmentId
  });

  const handleNavigateCurrentFilterTest = (assessmentId) => {
    if (currentFilter === "All") {
      // navigate(
      //   `${ROUTE_CONSTANT.QUIZ}?assessmentId=${PERSONALITY_TEST_ASSESSMENT_ID}&newt=true`
      // );
      const path = PathHelper(APP_NAVIGATION.QUIZ, currentLocale);
      navigate(
        `${path.next}?assessmentId=${PERSONALITY_TEST_ASSESSMENT_ID}&newt=true`,
      ); // for example
      // scrollAndHighlightElement("new-test-button");
      // setOpenNewTest(true);
    } else {
      const path = PathHelper(APP_NAVIGATION.QUIZ, currentLocale);
      navigate(`${path.next}?assessmentId=${assessmentId}&newt=true`);
      // navigate(`${ROUTE_CONSTANT.QUIZ}?assessmentId=${assessmentId}&newt=true`);
    }
  };

  const assessmentFilterOption =
    assessmentTitle?.length &&
    assessmentTitle?.map((item) => {
      const matchingIcon = assessmentIcons.find(
        (iconItem) =>
          item?.id.trim().toLowerCase() === iconItem.key.trim().toLowerCase(),
      );
      return {
        title: item?.title,
        id: item?.id,
        icon: matchingIcon ? matchingIcon.icon : PersonalityIcon,
      };
    });

  const attemptAssessmentIds = useMemo(() => {
    if (!assessmentAttemptData?.length) return []; // Handle empty case

    // Extract IDs and remove duplicates using Set
    const uniqueIds = [
      ...new Set(assessmentAttemptData.map((item) => item.assessmentId)),
    ];

    return uniqueIds;
  }, [assessmentAttemptData]); // Recompute only if assessmentAttemptData changes
  const settingsPath = PathHelper(APP_NAVIGATION.SETTINGS, currentLocale);
  const planPath = PathHelper(APP_NAVIGATION.PLAN, currentLocale);

  return (
    <div className="" id="dashboard-main-container">
      <Header personalityImage={personalityImage} />
      {isButtonLoading || isLoading || isUserAssessmentResulMapDataLoading ? (
        <Loader
          isLoading={
            isButtonLoading || isLoading || isUserAssessmentResulMapDataLoading
          }
        />
      ) : (
        <div className="w-full" id="dashboard-content-wrapper">
          <div
            className="max-w-[1260px] mx-auto text-center bg-white border-b border-gray-300 flex-col relative md:mt-[10px]"
            id="dashboard-header-section"
          >
            {/* ------------------------------------TOP SECTION------------------------------------ */}
            <div
              className="w-full mx-auto p-[10px] flex items-center "
              id="dashboard-personality-banner-container"
            >
              {notAttemptedAssessments.length === 0 ? (
                <div
                  className="min-w-[300px] w-full max-h-full rounded-[20px] shadow-lg flex items-center bg-cover bg-center relative p-[10px] pb-0 lg:p-[20px] lg:pb-[0px]"
                  id="dashboard-personality-banner"
                  style={{
                    backgroundImage: bannerImage
                      ? `url(${bannerImage})`
                      : "none",
                    backgroundColor: "#E1E1FF", // Fallback background color
                  }}
                >
                  <img
                    src={personalityImage} // Add a default image path
                    alt="Dashboard Avatar"
                    className="hidden md:block h-72 w-auto max-w-full max-h-full
      object-contain object-center aspect-square "
                    onError={(e) => {
                      e.target.src = "/default-avatar.png"; // Fallback on image load error
                    }}
                  />

                  <img
                    src={personalityImage || "/default-avatar.png"} // Add a default image path
                    alt="Dashboard Avatar"
                    className="md:hidden max-h-full w-[140px] h-auto mr-2 pt-[10px]"
                    onError={(e) => {
                      e.target.src = "/default-avatar.png"; // Fallback on image load error
                    }}
                  />
                  <h1 className="font-bold text-insightful-black text-left lg:w-auto max-w-max lg:px-[20px] lg:ml-[20px]">
                    <span className="block text-[20px] md:text-[36px] lg:text-[62px] font-bold text-white leading-none">
                      {personalityName || "Find Your Personality"}
                    </span>
                    <span
                      className={`block text-[16px] md:text-[26px] font-semibold`}
                      style={{ color: personalityColorDark || "#000000" }}
                    >
                      {personalityType && (
                        <span className="text-insightful-black">
                          {t("dashboard.personality")}:{" "}
                        </span>
                      )}
                      {personalityInProgress && !personalityType && (
                        <>{t("dashboard.progress_message")}</>
                      )}

                      {personalityType && personalityType}

                      {!personalityType &&
                        !personalityInProgress &&
                        t("dashboard.highlighted_test")}
                    </span>
                    <span className="block text-[14px] md:text-[20px] text-white leading-tight font-normal text-wrap">
                      {insightfulContent?.content?.Content?.centerheading || ""}
                    </span>
                    <span className="w-fit hidden lg:flex">
                      {!personalityType && !personalityInProgress && (
                        <AppButton
                          id="dashboard-take-test-button"
                          type="button"
                          className="flex mt-[10px] justify-center items-center h-max w-full max-w-[320px] py-2 border border-transparent rounded-full shadow-sm text-[16px] lg:text-[20px] font-bold text-white bg-[#FE6634] hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
                          onClick={() => {
                            handleNavigateCurrentFilterTest(currentFilter);
                          }}
                        >
                          {t("dashboard.take_test_cta")}
                        </AppButton>
                      )}
                    </span>
                    <span className="w-fit hidden lg:flex">
                      {personalityInProgress && !personalityType && (
                        <AppButton
                          id="dashboard-complete-test-button"
                          type="button"
                          className="flex mt-[10px] justify-center items-center h-max w-full max-w-[320px] py-2 border border-transparent rounded-full shadow-sm text-[16px] lg:text-[20px] font-bold text-white bg-[#FE6634] hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
                          onClick={() => {
                            handleContinueTest(
                              PERSONALITY_TEST_ASSESSMENT_ID,
                              inCompletePersonalityAssessmentId,
                              isPremiumOrGuest,
                            );
                            // scrollAndHighlightElement("new-test-button");
                            // setOpenNewTest(true);
                          }}
                        >
                          {t("dashboard.complete_test_cta")}
                        </AppButton>
                      )}
                    </span>
                  </h1>
                </div>
              ) : (
                <div
                  className="min-w-[300px] w-full max-h-full rounded-[20px] shadow-lg flex items-center bg-cover bg-center relative pb-0 lg:p-[20px] lg:pb-[0px] py-4"
                  id="dashboard-quiz-banner"
                  style={{
                    // backgroundImage: bannerImage ? `url(${bannerImage})` : "none",
                    backgroundColor: "#E1E1FF", // Fallback background color
                  }}
                >
                  <DashboardQuiz
                    handleContinueTest={handleContinueTest}
                    getAllAssessmentData={getAllAssessmentData}
                    attemptAssessmentIds={attemptAssessmentIds}
                  />
                </div>
              )}
            </div>
            {/* ------------------------------------SECOND SECTION------------------------------------ */}
            <div
              className="mx-auto my-1 flex flex-col items-center md:px-[10px] lg:p-[10px]"
              id="dashboard-main-content-section"
            >
              <div
                className="grid grid-cols-12 gap-3 lg:gap-4 w-full max-w-[1260px]"
                id="dashboard-main-grid"
              >
                {/* ------------------------------------LEFT COLUMN------------------------------------ */}

                <div
                  className="col-span-12 md:col-span-3  relative flex md:px-0"
                  id="dashboard-left-column"
                >
                  <div
                    className="lg:max-w-[315px] max-h-max md:max-h-[920px] h-max lg:h-[920px] w-full bg-insightful-lightest-gray md:py-[10px] lg:py-[20px] rounded-[20px]  items-center flex-col"
                    id="dashboard-sidebar-panel"
                  >
                    <div className="w-full px-[20px] bg-white md:bg-insightful-lightest-gray">
                      <button
                        id="new-test-button"
                        className={`flex justify-center items-center h-[40px] w-full border border-transparent rounded-full shadow-sm text-[20px] font-bold text-white bg-[#FE6634] hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 `}
                        onClick={() => {
                          setOpenNewTest(!openNewTest);
                          setPopoverOpen({});
                        }}
                      >
                        <span onClick={handleTestClick}>
                          {" "}
                          {t("dashboard.new_test_cta")}
                        </span>
                        <svg
                          className="w-2.5 h-2.5 ms-3"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 10 6"
                        >
                          <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="m1 1 4 4 4-4"
                          />
                        </svg>
                      </button>
                      <AppPopOver
                        id="dashboard-new-test-popover"
                        isPopoverOpen={openNewTest}
                        content={assessmentOptions}
                        className="fixed px-[10px] py-[10px] w-[315px] lg:w-full items-center top-12 lg:top-16 right-0 left-0 mx-auto bg-white max-h-[70vh] overflow-y-auto z-10"
                        classNameList="text-left flex-reverse flex flex-col-reverse text-[16px] !important font-medium px-[10px] [&>li]:rounded-full"
                        setIsPopoverOpen={setOpenNewTest}
                        closeOnScroll={false}
                      />
                    </div>

                    {/* Filter Tests Bottom Mobile Panel */}
                    <div
                      id="filter-tests-mobile-panel"
                      className={`md:hidden fixed  flex items-center justify-center flex-col mx-auto w-full bottom-0 h-max py-[10px] bg-white  shadow-lg rounded-t-[20px] transform transition-transform duration-300 ease-in-out z-[1000] ${
                        isFilterPanelOpen
                          ? "translate-y-0 scroll-smooth"
                          : "translate-y-full scroll-smooth"
                      }`}
                    >
                      <div
                        className="w-full px-[20px] h-max"
                        id="filter-tests-mobile-content"
                      >
                        <div
                          className=" flex justify-between align-center items-center md:hidden max-w-full w-full bg-transparent md:px-0 my-2"
                          id="filter-tests-mobile-header"
                        >
                          <h2
                            className="font-[Montserrat] text-[24px] text-insightful-black font-bold text-left"
                            id="filter-tests-mobile-title"
                          >
                            {t("dashboard.filter_tests_cta")}
                          </h2>
                          <button
                            id="filter-tests-mobile-close-button"
                            style={{
                              color: personalityColorDark,
                              backgroundColor: personalityColorLight,
                            }}
                            className={`flex py-1 px-2 items-center min-w-max text-[16px] rounded-full`}
                            onClick={toggleFilterPanel}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                personalityColorMedium)
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                personalityColorLight)
                            }
                            onFocus={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                personalityColorLight)
                            }
                            onBlur={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                personalityColorLight)
                            }
                          >
                            {t("dashboard.close_button")}
                            <span className="text-[24px] ml-1">&times;</span>
                          </button>
                        </div>
                        <div
                          className="w-full flex-row overflow-y-auto overscroll-contain  h-[200px]"
                          id="filter-tests-mobile-list"
                        >
                          <button
                            id="dashboard-filter-all-mobile-button"
                            onClick={() => {
                              setCurrentFilter("All");
                              toggleFilterPanel();
                            }}
                            className="flex items-center font-medium text-[16px] text-insightful-black mb-2 text-left w-full hover:bg-insightful-lightest-gray focus:bg-insightful-lightest-gray rounded-[10px] py-[8px] px-[8px]"
                          >
                            <img
                              src={AllIcon}
                              alt="All"
                              className="w-6 h-6 mr-2"
                            />
                            {t("dashboard.all_text")}
                          </button>
                          {assessmentFilterOption.length &&
                            [...assessmentFilterOption]
                              .sort((a, b) => a.title.localeCompare(b.title))
                              .map((item) => {
                                return (
                                  <button
                                    id={`dashboard-filter-${item?.id}-mobile-button`}
                                    onClick={() => {
                                      setCurrentFilter(item?.id);
                                      toggleFilterPanel();
                                    }}
                                    className="flex items-center font-medium text-[16px] text-insightful-black mb-3 text-left w-full hover:bg-insightful-light-gray focus:bg-insightful-light-gray rounded-[20px] py-[8px] px-[8px]"
                                  >
                                    <img
                                      src={item?.icon}
                                      alt="All"
                                      className="w-6 h-6 mr-2"
                                    />
                                    {item?.title}
                                  </button>
                                );
                              })}

                          {/* <button className="opacity-40 pointer-events-none flex items-center font-medium text-[16px] text-insightful-black mb-2 text-left w-full hover:bg-insightful-lightest-gray focus:bg-insightful-lightest-gray rounded-[10px] py-[8px] px-[8px]">
                          <img
                            src={CareerGuidence}
                            alt="Stress Relief"
                            className="w-6 h-6 mr-2"
                          />
                          Stress Relief
                        </button> */}
                          {/* <button className="opacity-40 pointer-events-none flex items-center font-medium text-[16px] text-insightful-black mb-2 text-left w-full hover:bg-insightful-lightest-gray focus:bg-insightful-lightest-gray rounded-[10px] py-[8px] px-[8px]">
                          <img
                            src={RelationShip}
                            alt="Creativity Test"
                            className="w-6 h-6 mr-2"
                          />
                          Creativity Test
                        </button> */}
                          <button
                            id="dashboard-filter-learning-style-mobile-button"
                            className="opacity-40 pointer-events-none flex items-center font-medium text-[16px] text-insightful-black mb-2 text-left w-full hover:bg-insightful-lightest-gray focus:bg-insightful-lightest-gray rounded-[10px] py-[8px] px-[8px]"
                          >
                            <img
                              src={LearningStyle}
                              alt="Learning Style"
                              className="w-6 h-6 mr-2"
                            />
                            {t("dashboard.learning_style")}
                          </button>
                          <button
                            id="dashboard-filter-stress-management-mobile-button"
                            className="opacity-40 pointer-events-none flex items-center font-medium text-[16px] text-insightful-black mb-2 text-left w-full hover:bg-insightful-lightest-gray focus:bg-insightful-lightest-gray rounded-[10px] py-[8px] px-[8px]"
                          >
                            <img
                              src={StressManagement}
                              alt="Stress Management"
                              className="w-6 h-6 mr-2"
                            />
                            {t("dashboard.stress_management")}
                          </button>
                          {/* <button className="opacity-40 pointer-events-none flex items-center font-medium text-[16px] text-insightful-black mb-2 text-left w-full hover:bg-insightful-lightest-gray focus:bg-insightful-lightest-gray rounded-[10px] py-[8px] px-[8px]">
                          <img
                            src={GrowthOpportunities}
                            alt="Interpersonal Skills"
                            className="w-6 h-6 mr-2"
                          />
                          Interpersonal Skills
                        </button> */}
                          {/* <button className="opacity-40 pointer-events-none flex items-center font-medium text-[16px] text-insightful-black mb-2 text-left w-full hover:bg-insightful-lightest-gray focus:bg-insightful-lightest-gray rounded-[10px] py-[8px] px-[8px]">
                          <img
                            src={CommunitySupport}
                            alt="Leadership Style"
                            className="w-6 h-6 mr-2"
                          />
                          Leadership Style
                        </button> */}
                        </div>
                      </div>

                      {/* <hr className="border-t border-insightful-light-gray w-full my-6" />

                    <div className="flex-col justify-center text-center mb-6 oveflow-visible px-[20px]">
                      <p className="font-semibold text-[16px] text-insightful-black mb-4">
                        If can't find the test you're looking we can get it in
                        for you request it.
                      </p>
                      <button
                        type="button"
                        className="flex-col justify-center items-center h-[30px] w-[150px] border border-transparent rounded-full shadow-sm text-[12px] font-semibold text-insightful-black bg-[#D9D9D9] hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
                      >
                        <span>REQUEST TEST</span>
                      </button>
                    </div> */}

                      <hr className="border-t border-insightful-light-gray w-full my-6" />

                      <div
                        className="flex items-center flex-col justify-center text-center mb-6 px-[20px]"
                        id="dashboard-invite-friends-section"
                      >
                        <p
                          className="font-semibold text-[16px] text-insightful-black mb-4"
                          id="dashboard-invite-friends-text"
                        >
                          {t("dashboard.remaining_invites_text")}{" "}
                          <span style={{ color: personalityColorDark }}>
                            {/* 8 userInvitations */}
                            {parseInt(billingDetails?.maxSubUserCount) -
                              parseInt(guestUserCount) || 0}{" "}
                          </span>{" "}
                          {t("dashboard.invite_friend_info")}
                        </p>
                        <button
                          type="button"
                          id="dashboard-invite-friend-button"
                          className="flex flex-col justify-center items-center h-[30px] w-[150px] border border-transparent rounded-full shadow-sm text-[12px] font-semibold text-insightful-black bg-[#D9D9D9] hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
                          onClick={() => {
                            if (isPremiumOrGuest) {
                              if (
                                guestUserCount < billingDetails?.maxSubUserCount
                              ) {
                                setOpenCreateUser(true);
                                toggleFilterPanel();
                              } else {
                                toast.warning(
                                  t("settings.max_user_reached_msg"),
                                );
                              }
                            } else {
                              const path = PathHelper(
                                APP_NAVIGATION.PLAN,
                                currentLocale,
                              );
                              navigate(`${path.next}`); // for example
                              // navigate(ROUTE_CONSTANT.PAYMENT_PLAN);
                            }
                          }}
                        >
                          <span> {t("dashboard.invite_friend_cta")} </span>
                        </button>

                        <Link
                          to={
                            isPremiumOrGuest
                              ? `${settingsPath.next}?steps=user-management#user-management`
                              : planPath.next
                          }
                          className={`my-2
                        style={{ color: personalityColorDark }}
                         underline-offset-2 underline`}
                        >
                          {t("dashboard.manage_invites_cta")}
                        </Link>
                      </div>
                    </div>
                    <CreateNewUserModel
                      id="dashboard-create-new-user-modal"
                      isOpen={openCreateUser}
                      setOpen={setOpenCreateUser}
                      parentId={userGUID}
                      CreateGuestUserConnect={GuestUserChangesConnect}
                      GetGuestUserConnect={GetGuestUserConnect}
                      setGuestUserData={setGuestUserData}
                      setGuestUserCount={setGuestUserCount}
                      parentEmail={userData?.email}
                      guestUserData={guestUserData}
                      currentLocale={currentLocale}
                      t={t}
                    />
                    <CreateNewUserModel
                      id="dashboard-send-to-partner-modal"
                      isOpen={openSendToPartner}
                      setOpen={setOpenSendToPartner}
                      parentId={userGUID}
                      CreateGuestUserConnect={sendToPartnerReportOnEmailConnect}
                      parentEmail={userData?.email}
                      guestUserData={guestUserData}
                      assessmentAttemptId={selectedAssessmentAttemptId}
                      assessmentId={selectedAssessmentId}
                      type={"send_to_partner"}
                      assessmentMapId={selectedAssessmentMapId}
                      t={t}
                      currentLocale={currentLocale}
                      isPremiumOrGuest={isPremiumOrGuest}
                      guestUserCount={guestUserCount}
                      maxSubUserCount={billingDetails?.maxSubUserCount}
                    />
                    <CreateNewUserModel
                      modalId="dashboard-send-to-friend-modal"
                      isOpen={openSendToFriend}
                      setOpen={setOpenSendToFriend}
                      parentId={userGUID}
                      CreateGuestUserConnect={sendToFriendReportOnEmailConnect}
                      parentEmail={userData?.email}
                      guestUserData={guestUserData}
                      assessmentAttemptId={selectedAssessmentAttemptId}
                      assessmentId={selectedAssessmentId}
                      type={"send_to_friend"}
                      reportType={selectedReportType}
                      id={selectedResultId}
                      t={t}
                      currentLocale={currentLocale}
                    />
                    {/* Overlay to close the panel when clicking outside */}
                    {isFilterPanelOpen && (
                      <div
                        className="fixed inset-0 bg-black bg-opacity-50 z-30 max-h-[100vh]"
                        onClick={toggleFilterPanel}
                      ></div>
                    )}

                    <div id="filter-tests-desktop" className="hidden md:block ">
                      <hr className="border-t border-insightful-light-gray w-full my-6" />
                      <div className="w-full px-[20px] max-h-[570px] overflow-y-auto">
                        <h2 className="font-bold text-[24px] mb-4 text-left text-insightful-black">
                          {t("dashboard.filter_tests_cta")}
                        </h2>
                        <button
                          id="dashboard-filter-all-desktop-button"
                          onClick={() => setCurrentFilter("All")}
                          className="flex items-center font-medium text-[16px] text-insightful-black mb-3 text-left w-full hover:bg-insightful-light-gray focus:bg-insightful-light-gray rounded-[20px] lg:py-[8px] lg:px-[8px]"
                        >
                          <img
                            src={PersonalityIcon}
                            alt="All"
                            className="w-6 h-6 mr-2"
                          />
                          {t("dashboard.all_text")}
                        </button>
                        {assessmentFilterOption.length &&
                          [...assessmentFilterOption]
                            .sort((a, b) => a.title.localeCompare(b.title))
                            .map((item) => {
                              return (
                                <button
                                  id={`dashboard-filter-${item?.id}-desktop-button`}
                                  onClick={() => setCurrentFilter(item?.id)}
                                  className="flex items-center font-medium text-[16px] text-insightful-black mb-3 text-left w-full hover:bg-insightful-light-gray focus:bg-insightful-light-gray rounded-[20px] lg:py-[8px] lg:px-[8px]"
                                >
                                  <img
                                    src={item?.icon}
                                    alt="All"
                                    className="w-6 h-6 mr-2"
                                  />
                                  {item?.title}
                                </button>
                              );
                            })}

                        {/* <button className="opacity-40 pointer-events-none flex items-center font-medium text-[16px] text-insightful-black mb-3 text-left w-full hover:bg-insightful-light-gray focus:bg-insightful-light-gray rounded-[20px] lg:py-[8px] lg:px-[8px]">
                        <img
                          src={CareerGuidence}
                          alt="Stress Relief"
                          className="w-6 h-6 mr-2"
                        />
                        Stress Relief
                      </button> */}
                        {/* <button className="opacity-40 pointer-events-none flex items-center font-medium text-[16px] text-insightful-black mb-3 text-left w-full hover:bg-insightful-light-gray focus:bg-insightful-light-gray rounded-[20px] lg:py-[8px] lg:px-[8px]">
                        <img
                          src={RelationShip}
                          alt="Creativity Test"
                          className="w-6 h-6 mr-2"
                        />
                        Creativity Test
                      </button> */}
                        <button
                          id="dashboard-filter-learning-style-desktop-button"
                          className="opacity-40 pointer-events-none flex items-center font-medium text-[16px] text-insightful-black mb-3 text-left w-full hover:bg-insightful-light-gray focus:bg-insightful-light-gray rounded-[20px] lg:py-[8px] lg:px-[8px]"
                        >
                          <img
                            src={LearningStyle}
                            alt="Learning Style"
                            className="w-6 h-6 mr-2"
                          />
                          {t("dashboard.learning_style")}
                        </button>
                        <button
                          id="dashboard-filter-stress-management-desktop-button"
                          className="opacity-40 pointer-events-none flex items-center font-medium text-[16px] text-insightful-black mb-3 text-left w-full hover:bg-insightful-light-gray focus:bg-insightful-light-gray rounded-[20px] lg:py-[8px] lg:px-[8px]"
                        >
                          <img
                            src={StressManagement}
                            alt="Stress Management"
                            className="w-6 h-6 mr-2"
                          />
                          {t("dashboard.stress_management")}
                        </button>
                        {/* <button className="opacity-40 pointer-events-none flex items-center font-medium text-[16px] text-insightful-black mb-3 text-left w-full hover:bg-insightful-light-gray focus:bg-insightful-light-gray rounded-[20px] py-[8px] px-[8px]">
                        <img
                          src={GrowthOpportunities}
                          alt="Interpersonal Skills"
                          className="w-6 h-6 mr-2"
                        />
                        Interpersonal Skills
                      </button> */}
                        {/* <button className="opacity-40 pointer-events-none flex items-center font-medium text-[16px] text-insightful-black mb-3 text-left w-full hover:bg-insightful-light-gray focus:bg-insightful-light-gray rounded-[20px] py-[8px] px-[8px]">
                        <img
                          src={CommunitySupport}
                          alt="Leadership Style"
                          className="w-6 h-6 mr-2"
                        />
                        Leadership Style
                      </button> */}
                      </div>

                      {/* <hr className="border-t border-insightful-light-gray w-full my-6" />

                    <div className="flex-col justify-center mb-6 oveflow-visible px-[20px]">
                      <p className="font-semibold text-[16px] text-insightful-black mb-4">
                        If can't find the test you're looking we can get it in
                        for you request it.
                      </p>
                      <button
                        type="button"
                        className="flex-col justify-center items-center h-[30px] w-[150px] border border-transparent rounded-full shadow-sm text-[12px] font-semibold text-insightful-black bg-[#D9D9D9] hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
                      >
                        <span>REQUEST TEST</span>
                      </button>
                    </div> */}

                      <hr className="border-t border-insightful-light-gray w-full my-6" />

                      <div className="flex  flex-col items-center justify-center mb-6 px-[20px]">
                        <p className="font-semibold text-[16px] text-insightful-black mb-4">
                          {t("dashboard.remaining_invites_text")}{" "}
                          <span style={{ color: personalityColorDark }}>
                            {parseInt(billingDetails?.maxSubUserCount) -
                              parseInt(guestUserCount) || 0}{" "}
                          </span>{" "}
                          {t("dashboard.invite_friend_info")}
                        </p>
                        <button
                          type="button"
                          id="dashboard-invite-friend-desktop-button"
                          className="flex flex-col justify-center items-center h-[30px] w-[150px] border border-transparent rounded-full shadow-sm text-[12px] font-semibold text-insightful-black bg-[#D9D9D9] hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
                          onClick={() => {
                            if (isPremiumOrGuest) {
                              if (
                                guestUserCount < billingDetails?.maxSubUserCount
                              ) {
                                setOpenCreateUser(true);
                              } else {
                                toast.warning(
                                  "Maximum number of users reached.",
                                );
                              }
                            } else {
                              navigate(`${planPath.next}`); // for example
                            }
                          }}
                        >
                          {t("dashboard.invite_friend_cta")}
                        </button>
                        <Link
                          id="dashboard-manage-invites-link"
                          style={{ color: personalityColorDark }}
                          to={
                            isPremiumOrGuest
                              ? `${settingsPath.next}?steps=user-management`
                              : planPath.next
                          }
                          className={`my-2
                      underline-offset-2 underline`}
                        >
                          {t("dashboard.manage_invites_cta")}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                {/* ------------------------------------MIDDLE COLUMN------------------------------------ */}
                <div
                  className="col-span-12 md:col-span-6  w-full mx-auto flex flex-col items-center"
                  id="dashboard-middle-column"
                >
                  <div
                    className="flex justify-between align-center items-center md:hidden max-w-[630px] w-full bg-transparent px-[10px] md:px-0 my-2"
                    id="dashboard-results-mobile-header"
                  >
                    <h2
                      className="font-[Montserrat] text-[24px] text-insightful-black font-bold text-left"
                      id="dashboard-your-results-title"
                    >
                      {t("dashboard.your_results_label")}
                    </h2>
                    <button
                      style={{
                        color: personalityColorDark,
                        backgroundColor: personalityColorLight,
                      }}
                      id="filter-tests-mobile-toggle-button"
                      className={`flex py-1 px-2 items-center text-[16px]  rounded-full  hover:bg-[${personalityColorMedium}] focus:bg-[${personalityColorMedium}]`}
                      onClick={toggleFilterPanel}
                    >
                      {t("dashboard.filter_tests_cta")}
                      <span>
                        <img
                          className="ml-2"
                          src={FilterTestIcon}
                          alt="Filter Tests Icon"
                        />
                      </span>
                    </button>
                  </div>
                  <div
                    className="max-w-full w-full max-h-[920px] h-max lg:h-[920px] bg-transparent px-[10px] md:px-0 overflow-y-auto"
                    id="dashboard-results-container"
                  >
                    <div
                      className="flex justify-center relative shadow-md rounded-[20px] w-full mx-auto items-center "
                      id="dashboard-results-table-wrapper"
                    >
                      <table
                        className="h-[200px] md:h-[920px] overflow-y-auto w-full text-[16px] text-left rtl:text-right rounded-[20px] bg-insightful-lightest-gray text-gray-500 dark:text-gray-400"
                        id="dashboard-results-table"
                      >
                        <thead className="rounded-[20px] text-[16px] text-insightful-gray uppercase bg-insightful-lightest-gray hover:bg-insightful-light-gray dark:bg-gray-700 relative dark:text-gray-400"></thead>
                        <tbody>
                          {filteredData?.length > 0 &&
                            filteredData?.map((item, index) => {
                              const status =
                                item &&
                                item?.personality &&
                                item?.personality !== null
                                  ? ASSESSMENT_STATUS.COMPLETED
                                  : ASSESSMENT_STATUS.IN_PROGRESS;
                              const translationStatus =
                                item &&
                                item?.personality &&
                                item?.personality !== null
                                  ? `${t("dashboard.completed")}`
                                  : `${t("dashboard.in_progress")}`;
                              const data = {
                                userGuid: userGUID,
                                assessmentAttemptId: item?.assessmentAttemptId,
                                locale: currentLocale,
                              };
                              const formattedTitle =
                                convertSpaceToHyphenAndLowerCase(item.title);
                              const reportType = item?.reportType;

                              const testType =
                                TEST_TYPES[item?.assessmentId] || "UnknownTest";
                              const getContent = () => {
                                if (status === ASSESSMENT_STATUS.COMPLETED) {
                                  const baseActions = [
                                    {
                                      id: "dashboard-view-report",
                                      label: `${t(
                                        "dashboard.view_report_cta",
                                      )}`,
                                      onClick: () => {
                                        handleViewReport(
                                          isPremiumOrGuest,
                                          item?.assessmentAttemptId,
                                          item?.assessmentId,
                                          item?.id,
                                          reportType,
                                        );
                                      },
                                      icon: ViewReportIcon,
                                      className: "text-red-500",
                                    },
                                    {
                                      id: "dasboard-retake-test",
                                      label: `${t("dashboard.retake_test")}`,
                                      icon: RetakeTestIcon,
                                      onClick: () => {
                                        handleRetakeTest(
                                          isPremiumOrGuest,
                                          item,
                                        );
                                      },
                                    },
                                    {
                                      id: "dasboard-share-report",
                                      label: `${t("dashboard.share_report")}`,
                                      onClick: () => {
                                        handleShareReport(
                                          isPremiumOrGuest,
                                          item,
                                        );
                                      },
                                      icon: ShareReportIcon,
                                    },
                                    {
                                      id: "dasboard-send-to-friend",
                                      label: `${t("dashboard.send_to_friend")}`,
                                      onClick: () => {
                                        handleSendToFriend(
                                          isPremiumOrGuest,
                                          item,
                                        );
                                      },
                                      icon: SendToFriendIcon,
                                    },
                                  ];

                                  // Hide standard View Report for RomanticCompatibilityTest
                                  const commonActions = baseActions;

                                  let specificActions = [];

                                  switch (testType) {
                                    case "PersonalityTest":
                                      specificActions = [
                                        {
                                          id: "dasboard-download-report",
                                          label: `${t(
                                            "dashboard.download_report",
                                          )}`,
                                          onClick: () => {
                                            handleDownloadReport(
                                              isPremiumOrGuest,
                                              item.assessmentAttemptId,
                                            );
                                          },
                                          icon: DownloadReportIcon,
                                        },
                                        {
                                          id: "dasboard-email-report",
                                          label: `${t(
                                            "dashboard.email_report",
                                          )}`,
                                          onClick: () => {
                                            handleEmailReport(
                                              isPremiumOrGuest,
                                              data,
                                              item,
                                            );
                                          },
                                          icon: EmailReportIcon,
                                        },
                                      ];
                                      break;

                                    case "CareerTest":
                                      // No specific actions for CareerTest
                                      break;

                                    case "BigFiveTest":
                                      // No specific actions for BigFiveTest
                                      break;

                                    case "BigFiveFacetsTest":
                                      break;

                                    case "EnneagramTest":
                                      break;
                                    case "LikeabilityTest":
                                      break;
                                    case "PersonalityDisorderTest":
                                      break;
                                    case "DiscPersonalityTest":
                                      break;
                                    case "ADHDTest":
                                      break;
                                    case "CareerPreferenceTest":
                                      break;
                                    case "EmotionalIntelligenceTest":
                                      break;
                                    case "DifficultPersonTest":
                                      break;
                                    case "DifficultPersonTest":
                                      break;
                                    case "AutismSpectrumTest":
                                      break;
                                    case "HighlySensitivePersonTest":
                                      break;
                                    case "AttachmentStyleTest":
                                      break;
                                    case "RomanticCompatibilityTest":
                                      specificActions = [
                                        ...(isParentUser &&
                                        convertToLowerCase(reportType) ===
                                          convertToLowerCase(
                                            ROMANTIC_COMPATIBILITY_REPORT_TYPE.PERSONALIZED,
                                          )
                                          ? [
                                              {
                                                id: "dasboard-send-to-partner",
                                                label: `${t(
                                                  "dashboard.send_to_partner",
                                                )}`,
                                                onClick: () => {
                                                  handleSendToPartner(
                                                    isPremiumOrGuest,
                                                    item,
                                                  );
                                                },
                                                icon: DownloadReportIcon,
                                              },
                                            ]
                                          : []),
                                      ];
                                      break;
                                    default:
                                      specificActions = [];
                                      break;
                                  }

                                  return [
                                    ...commonActions,
                                    ...specificActions,
                                    {
                                      id: "dasboard-delete-report",
                                      label: `${t("dashboard.delete_report")}`,
                                      onClick: () => {
                                        handleDeleteReport(
                                          isPremiumOrGuest,
                                          item.assessmentId,
                                          item.assessmentAttemptId,
                                          item.id,
                                        );
                                      },
                                      icon: DeleteReportIcon,
                                      className: "text-red-500",
                                    },
                                  ];
                                } else {
                                  return [
                                    {
                                      id: "dasboard-continue-report",
                                      label: `${t("dashboard.continue_test")}`,
                                      onClick: () => {
                                        handleContinueTest(
                                          item?.assessmentId,
                                          item?.assessmentAttemptId,
                                          isPremiumOrGuest,
                                        );
                                      },
                                      icon: PlayIcon,
                                    },
                                  ];
                                }
                              };

                              const isDynamicPersonalityAssessment =
                                convertToLowerCase(item?.assessmentId) ===
                                  convertToLowerCase(
                                    PERSONALITY_TEST_ASSESSMENT_ID,
                                  ) ||
                                convertToLowerCase(item?.assessmentId) ===
                                  convertToLowerCase(
                                    ENNEAGRAM_TEST_ASSESSMENT_ID,
                                  ) ||
                                convertToLowerCase(item?.assessmentId) ===
                                  convertToLowerCase(CAREER_TEST_ASSESSMENT_ID);

                              const staticPersonalityName =
                                personalityNamesAndGroups[item?.assessmentId]
                                  ?.name ?? null;
                              const staticPersonalityGroup =
                                personalityNamesAndGroups[item?.assessmentId]
                                  ?.group ?? null;

                              const pGroup =
                                item?.personality && item?.personality !== null
                                  ? item?.personality?.role?.toLowerCase()
                                  : isDynamicPersonalityAssessment
                                    ? personalityGroup
                                    : staticPersonalityGroup;

                              const pName =
                                item?.personality && item?.personality !== null
                                  ? item?.nameEnglishCode?.toLowerCase()
                                  : isDynamicPersonalityAssessment
                                    ? personalityNameEnglishCode
                                    : staticPersonalityName;

                              return (
                                <React.Fragment key={index}>
                                  <tr className="flex justify-between max-h-max h-[100px] p-2 w-full mx-0 first:rounded-t-[20px] last:rounded-b-[20px] bg-insightful-lightest-gray hover:bg-insightful-light-gray border-b last:border-b-0 border-insightful-light-gray dark:bg-gray-800 dark:border-gray-700 items-center">
                                    <td className="min-w-max w-[50px] h-auto p-4 rounded-full overflow-hidden">
                                      <img
                                        src={getImage(
                                          pGroup,
                                          pName,
                                          true,
                                          gender || userData?.gender,
                                          reportType,
                                        )}
                                        alt="Profile"
                                        className="object-cover rounded-full transition-transform transform scale-110 w-16 h-16 lg:mx-4 bg-gray-300"
                                      />
                                    </td>

                                    {/* Title Section */}
                                    <td className="flex flex-col justify-center items-start w-full pl-4">
                                      <p className="text-gray-500 font-bold text-sm sm:text-base">
                                        {item?.title}
                                      </p>
                                      <p className="text-gray-500 font-bold text-xs">
                                        {item?.subtitle}
                                      </p>

                                      <p
                                        className={`text-xs sm:text-sm text-green-600 cursor-pointer`}
                                        onClick={() => {
                                          if (
                                            status ===
                                            ASSESSMENT_STATUS.IN_PROGRESS
                                          ) {
                                            dispatch(
                                              PushAssessmentAttemptIdToFunnelStep(
                                                item?.assessmentAttemptId,
                                              ),
                                            );
                                            dispatch(
                                              PushQuizCompleteToFunnelStep(
                                                false,
                                              ),
                                            );
                                            dispatch(
                                              PushBackClickCountToFunnelStep(0),
                                            );
                                            const path = PathHelper(
                                              APP_NAVIGATION.QUIZ,
                                              currentLocale,
                                            );
                                            navigate(
                                              `${path.next}?assessmentId=${item.assessmentId}&assessmentAttemptId=${item?.assessmentAttemptId}`,
                                            ); // for example
                                            // navigate(
                                            //   `${ROUTE_CONSTANT.QUIZ}?assessmentId=${item.assessmentId}&assessmentAttemptId=${item?.assessmentAttemptId}`
                                            // );
                                          }
                                        }}
                                      >
                                        {translationStatus}
                                      </p>

                                      <p className="block md:hidden text-gray-500 text-xs sm:text-sm">
                                        {moment(item?.createdOn).format(
                                          "MM/DD/YYYY",
                                        )}
                                      </p>
                                    </td>

                                    <td className="hidden md:table-cell px-4 py-4 sm:px-6 sm:py-8 text-right">
                                      <p className="text-gray-500 text-xs sm:text-sm">
                                        {moment(item?.createdOn).format(
                                          "MM/DD/YYYY",
                                        )}
                                      </p>
                                    </td>

                                    <td className="px-4 py-4 text-right flex md:table-cell relative rounded-full items-center">
                                      <button
                                        id={`three-dots-button-dashboard-assessment-${index}`}
                                        className="text-insightful-gray hover:text-insightful-black text-4xl font-bold text-left"
                                        onClick={() => {
                                          if (window.innerWidth >= 768) {
                                            handlePopoverClick(index);
                                          } else {
                                            setTestPanelOpen(
                                              item?.assessmentAttemptId,
                                            );
                                          }
                                        }}
                                      >
                                        &#x22EE;
                                      </button>
                                      {popoverOpen === index && (
                                        <div
                                          className="hidden md:block"
                                          data-popover-trigger
                                        >
                                          <AppPopOver
                                            className="text-right font-semibold text-xs bg-white"
                                            classNameList="text-[14px] text-left"
                                            isPopoverOpen={
                                              popoverOpen === index
                                            }
                                            setIsPopoverOpen={setPopoverOpen}
                                            content={getContent()}
                                            forceDownward={index < 5}
                                            enableDynamicPositioning={true}
                                          />
                                        </div>
                                      )}
                                    </td>
                                  </tr>
                                </React.Fragment>
                              );
                            })}
                          {/* <tr>
                            <td colSpan="4" className="text-center py-8">
                              <p className="text-insightful-black text-[20px]">
                                {t("dashboard.find_personality_test_text")}
                              </p>
                              <AppButton
                                type="button"
                                className="flex mt-[10px] justify-center items-center h-max w-full max-w-[320px] py-2 border border-transparent rounded-full shadow-sm text-[16px] lg:text-[20px] font-bold text-white bg-[#FE6634] hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
                                onClick={() => {
                                  scrollAndHighlightElement("new-test-button");
                                  setOpenNewTest(true);
                                }}
                              >
                                Take The Test
                              </AppButton>
                            </td>
                          </tr> */}

                          {filteredData?.length === 0 && (
                            <tr className="w-full">
                              <td className="flex flex-col justify-center items-center text-center h-full">
                                <p className="text-insightful-black text-[20px] w-full mx-auto">
                                  {t("dashboard.no_tests_message")}
                                </p>
                                <AppButton
                                  id="dashboard-no-tests-take-test-button"
                                  type="button"
                                  className="flex mt-[10px] justify-center items-center h-max w-full max-w-[320px] py-2 border border-transparent rounded-full shadow-sm text-[16px] lg:text-[20px] font-bold text-white bg-[#FE6634] hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
                                  onClick={() => {
                                    handleNavigateCurrentFilterTest(
                                      currentFilter,
                                    );
                                  }}
                                >
                                  {t("dashboard.take_test_cta")}
                                </AppButton>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* Mobile Test Panel */}
                {testPanelOpen !== null && (
                  <>
                    <div className="md:hidden max-h-max">
                      <div
                        className={`fixed flex flex-col mx-auto w-full bottom-0 max-h-max bg-white rounded-t-[20px] p-4 z-[1000] transform transition-transform duration-300 ease-in-out ${
                          testPanelOpen !== null
                            ? "translate-y-0"
                            : "translate-y-full scroll-smooth"
                        }`}
                      >
                        <div className="flex justify-between items-center mb-4">
                          <div className="text-left items-center px-2">
                            <h2 className="text-xl font-bold">
                              {selectedAssessment?.title}
                            </h2>
                            <p className="text-xs text-gray-500 ml-1">
                              {moment(selectedAssessment?.createdOn).format(
                                "MM/DD/YYYY",
                              )}
                              {selectedAssessment?.personality ? (
                                <span className="text-xs ml-2 text-green-500">
                                  {t("dashboard.complete_status")}
                                </span>
                              ) : (
                                <span className="text-xs ml-2 text-insightful-orange">
                                  {t("dashboard.incomplete_status")}
                                </span>
                              )}
                            </p>
                          </div>
                          <button
                            id="mobile-test-panel-button"
                            style={{
                              color: personalityColorDark,
                              backgroundColor: personalityColorLight,
                            }}
                            className={`flex px-2 items-center min-w-max text-[16px]  rounded-full hover:bg-[${personalityColorMedium}] focus:bg-[${personalityColorMedium}]`}
                            onClick={() => setTestPanelOpen(null)}
                          >
                            {t("dashboard.close_button")}
                            <span className="text-[24px] ml-1">&times;</span>
                          </button>
                        </div>
                        <div className="space-y-[11px]">
                          {getMobileActions().map((item, index) =>
                            item.type === "divider" ? (
                              <hr
                                key={index}
                                className="border-t border-gray-200"
                              />
                            ) : (
                              <button
                                key={index}
                                id={`dashboard-mobile-action-${item?.label
                                  ?.toLowerCase()
                                  ?.replace(/\s+/g, "-")}-button`}
                                className={`flex items-center w-full p-2 hover:bg-gray-100 rounded ${
                                  item.className || ""
                                }`}
                                onClick={item.onClick}
                              >
                                <img
                                  src={item.icon}
                                  alt={item.label}
                                  className="w-6 h-6 mr-2"
                                />
                                <span>{item.label}</span>
                              </button>
                            ),
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Overlay to close the panel when clicking outside */}
                    <div
                      className="fixed inset-0 bg-black bg-opacity-50 z-30 max-h-[100vh]"
                      onClick={() => setTestPanelOpen(null)}
                    ></div>
                  </>
                )}
                {/* Share Modal */}
                {shareModalOpen && (
                  <ShareProfileModal
                    id="dashboard-share-profile-modal"
                    isOpen={shareModalOpen}
                    onClose={() => setShareModalOpen(false)}
                    personalityImage={getImage(
                      selectedTest?.personality?.role.toLowerCase()
                        ? selectedTest?.personality?.role.toLowerCase()
                        : personalityGroup.toLowerCase(),
                      selectedTest?.nameEnglishCode.toLowerCase()
                        ? selectedTest?.nameEnglishCode.toLowerCase()
                        : personalityNameEnglishCode.toLowerCase(),
                      true,
                      gender || userData?.gender,
                    )}
                    assessmentTitle={
                      selectedTest?.title
                        ? selectedTest?.title
                        : userAssessmentResult.assessmentTitle
                    }
                    assessmentId={
                      selectedTest?.assessmentId
                        ? selectedTest?.assessmentId
                        : userAssessmentResult?.assessmentId
                    }
                    assessmentAttemptId={
                      selectedTest?.assessmentAttemptId
                        ? selectedTest?.assessmentAttemptId
                        : latestAssessmentAttemptId
                    }
                    personalityType={
                      selectedTest?.personality?.title
                        ? selectedTest?.personality?.title
                        : personalityType
                    }
                    personalityName={
                      selectedTest?.personality?.name
                        ? selectedTest?.personality?.name
                        : personalityName
                    }
                    personalityGroup={
                      selectedTest?.personality?.role
                        ? selectedTest?.personality?.role
                        : personalityGroup
                    }
                    userGUID={userGUID}
                    saveUserSocialButtonClickConnect={
                      saveUserSocialButtonClickConnect
                    }
                  />
                )}
                {/* ------------------------------------RIGHT COLUMN------------------------------------ */}
                <div
                  className="col-span-12 md:col-span-3  flex px-[10px] md:px-0"
                  id="dashboard-right-column"
                >
                  <div
                    className="lg:max-w-[315px] max-h-[920px] h-max lg:h-[920px] w-full bg-insightful-lightest-gray rounded-[20px] pb-[20px] items-center contain-content"
                    id="dashboard-personality-card"
                  >
                    <div
                      className="relative max-h-max mb-1 overflow-hidden flex justify-center lg:block lg:justify-start"
                      id="dashboard-personality-avatar-section"
                    >
                      <img
                        src={personalityImage} // getTypeImage(personalityType, "avatar-small", gender)
                        alt="Avatar Image"
                        className="z-10 absolute object-cover h-32"
                        id="dashboard-personality-avatar"
                      />
                      <img
                        src={bannerImage} // getTypeImage(personalityType, "background-small", gender)
                        alt="Avatar Background"
                        className="inset-0 w-full h-[106px] object-cover rounded-t-lg"
                        id="dashboard-personality-background"
                      />
                    </div>

                    <div
                      className="flex flex-col justify-between relative px-[20px] items-center"
                      id="dashboard-personality-content"
                    >
                      {personalityType && (
                        <div
                          className="w-full pt-[10px] flex justify-center lg:justify-center gap-[10px]"
                          id="dashboard-personality-share-buttons"
                        >
                          <button
                            id="dashboard-share-report-button"
                            onClick={() => {
                              handleShareReport(
                                isPremiumOrGuest,
                                selectedAssessment,
                              );
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                personalityColorLight)
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "transparent")
                            }
                            className="aspect-square w-max bg-[#d9d9d9] rounded-full flex items-center justify-center"
                          >
                            <img
                              src={shareIcon}
                              alt="Sharing"
                              className="w-[40px] h-auto hover:text-insightful-purple"
                            />
                          </button>

                          <button
                            id="dashboard-send-to-friend-button"
                            onClick={() => {
                              const data = {
                                assessmentAttemptId: latestAssessmentAttemptId,
                                assessmentId: latestAssessmentId,
                              };
                              handleSendToFriend(isPremiumOrGuest, data);
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                personalityColorLight)
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "transparent")
                            }
                            className="aspect-square w-max bg-[#d9d9d9] rounded-full flex items-center justify-center"
                          >
                            <img
                              src={emailIcon}
                              alt="Email Sharing"
                              className="w-[40px] h-auto hover:text-insightful-purple"
                            />{" "}
                          </button>
                        </div>
                      )}
                      <div className="w-full pt-[10px] flex flex-col justify-center">
                        <p
                          style={{ color: personalityColorDark }}
                          className={`font-semibold text-center lg:text-center text-[16px]`}
                        >
                          {t("dashboard.personality_type_message")}
                        </p>
                        <div className="text-center lg:text-center">
                          <span
                            className={`font-semibold text-[#4A4A4A] text-[20px]`}
                          >
                            {personalityName ||
                              t("dashboard.yet_to_be_discover")}
                          </span>
                          &nbsp;
                          <span
                            style={{ color: personalityColorDark }}
                            className={`font-normal  text-[20px] text-center lg:text-left`}
                          >
                            {personalityType}
                          </span>
                        </div>
                      </div>
                      <div className="w-full py-[10px] flex flex-col justify-center">
                        {personalityType && (
                          <p className="text-left text-[#4A4A4A] text-[16px] mt-2">
                            {/* <span className="font-bold">{personalityType}</span> */}
                            {insightfulContent?.content?.Content
                              ?.rightheading || ""}
                          </p>
                        )}
                        {personalityInProgress && !personalityType && (
                          <div className="w-full">
                            <AppButton
                              id="dashboard-personality-card-continue-test-button"
                              type="button"
                              className="flex mt-[10px] justify-center items-center h-max w-full max-w-[320px] py-2 border border-transparent rounded-full shadow-sm text-[16px] lg:text-[20px] font-bold text-white bg-[#FE6634] hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
                              onClick={() => {
                                handleContinueTest(
                                  PERSONALITY_TEST_ASSESSMENT_ID,
                                  inCompletePersonalityAssessmentId,
                                  isPremiumOrGuest,
                                );
                              }}
                            >
                              {t("dashboard.complete_test_cta")}
                            </AppButton>
                          </div>
                        )}

                        {!personalityType && !personalityInProgress && (
                          <div className="w-full">
                            <AppButton
                              id="dashboard-personality-card-take-test-button"
                              type="button"
                              className="flex mt-[10px] justify-center items-center h-max w-full max-w-[320px] py-2 border border-transparent rounded-full shadow-sm text-[16px] lg:text-[20px] font-bold text-white bg-[#FE6634] hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
                              onClick={() => {
                                handleNavigateCurrentFilterTest(currentFilter);
                              }}
                            >
                              {t("dashboard.take_test_cta")}
                            </AppButton>
                          </div>
                        )}
                      </div>
                      <div className="flex flex-col gap-10 mx-4 lg:mx-0 py-[10px]">
                        {tratiPercentage.map((item, index) => {
                          return (
                            <TraitProgressBar
                              key={index}
                              value={item.percentage}
                              labelLeft={item.leftTrait}
                              labelRight={item.rightTrait}
                              text={item?.traitTitle}
                              assessmentId={latestAssessmentId}
                              t={t}
                            />
                          );
                        })}
                      </div>
                      {personalityType && (
                        <div className="w-full pt-[40px]">
                          <AppButton
                            id="dashboard-view-report-button"
                            type="button"
                            className="flex mt-[10px] justify-center items-center h-[50px] w-full border border-transparent rounded-full shadow-sm text-[16px] lg:text-[20px] font-bold text-white bg-[#FE6634] hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
                            onClick={handleViewReportDashboard}
                            icon={Arrow}
                          >
                            {t("dashboard.view_report_cta")}
                          </AppButton>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Dashboard;
